import React from 'react';

import { FormattedDate as FormattedDateIntl } from '@skippay/core/i18n/intl';

interface Props extends Intl.DateTimeFormatOptions {
	value: Date | number | string;
}

function FormattedDate(props: Props): JSX.Element {
	return (
		<span className="u-nowrap">
			<FormattedDateIntl {...props} />
		</span>
	);
}

export default FormattedDate;
